import { render, staticRenderFns } from "./GQS-feedback-modal.vue?vue&type=template&id=32a0ed18"
import script from "./GQS-feedback-modal.vue?vue&type=script&lang=js"
export * from "./GQS-feedback-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports